import { useQuery } from "@tanstack/react-query";
import { CalendarEventServices } from "@/services/CalendarEventServices";
import { CalendarEvent, TimePeriod, SocialNetworkPostStatus } from "@/interfaces";

const EMPTY_EVENTS: CalendarEvent[] = [];

export const useCalendarEvents = (dateTime: Date, timePeriod: TimePeriod, coachId?: number, playerIds?: number[]) => {
  return useQuery({
    queryKey: [
      "calendarEvents",
      dateTime.toISOString(),
      timePeriod,
      coachId,
      [...(playerIds ?? [])].sort((a, b) => a - b).join(","),
    ],
    queryFn: async ({ signal }) => {
      const response = await CalendarEventServices.getCalendarEvents(
        dateTime,
        timePeriod,
        coachId,
        playerIds,
        undefined, // cancelToken handled by signal
        0,
        2000
      );

      // Processing failure_acked status as in the original component
      response.content.forEach(event => {
        event.postStatuses = event.postStatuses.map(el =>
          el === SocialNetworkPostStatus.FAILURE_ACKED ? SocialNetworkPostStatus.FAILED : el
        );
      });

      return response.content;
    },
    placeholderData: EMPTY_EVENTS,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
